export default {
  getItem(key) {
    return window.localStorage.getItem(key);
  },
  setItem(key, value) {
    window.localStorage.setItem(key, value);
  }
};



// WEBPACK FOOTER //
// ./src/utils/local-storage.js